<script>
  import { createEventDispatcher } from "svelte";
  import { t, lang } from "./i18n";

  import LangSpan from "./ui/LangSpan.svelte";
  import CloseButton from "./ui/CloseButton.svelte";
  import SearchBox from "./search/SearchBox.svelte";

  const dispatch = createEventDispatcher();
  const handleSelectResult = (event) => {
    dispatch("close");
    dispatch("select", event.detail);
  };
</script>

<div class="welcome-overlay">
  <div class="welcome">
    <CloseButton on:click={() => dispatch("close")} />
    <div class="inner">
      <h1><LangSpan key="welcome-title" /></h1>
      <p><LangSpan key="welcome-text" /></p>
      <div class="search-wrapper">
        <SearchBox on:select={handleSelectResult} placeholderText={t("welcome-search-placeholder", $lang)} />
      </div>
    </div>
  </div>
</div>

<style>
  .welcome-overlay {
    width: 100vw;
    height: calc(100vh - 100px);
    position: fixed;
    top: 100px;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  }

  .welcome {
    position: relative;
    top: -20vh;
    background: white;
    filter: drop-shadow(0 20px 13px rgb(0 0 0 / 0.03)) drop-shadow(0 8px 5px rgb(0 0 0 / 0.08));
    border-radius: 5px;
    max-width: 600px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .inner {
    padding: 1.7rem 2rem 1rem 2rem;
  }

  h1 {
    margin: 0 0 1rem 0;
    font-size: 1.5rem;
    font-weight: bold;
  }

  p {
    margin: 0;
  }

  .search-wrapper {
    padding: 1.5rem 0;
  }
</style>
